/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { LegacyDataTable, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableBody, LegacyDataTableToolsRow, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import cn from "classnames";
import type * as React from "react";
import TransitionAnimation from "~/components/TransitionAnimation/TransitionAnimation";
import BaseComponent from "../BaseComponent";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
import { getNavigationUrl } from "../PagingBaseComponent/PagingBaseComponent";
import styles from "./style.module.less";
interface SimpleDataTableProps<TData> {
    onToolsSection?: any;
    headerColumns: any[];
    headerColumnClassNames?: string[];
    rowColumnClassName?: string;
    tableClassName?: string;
    data: ReadonlyArray<TData>;
    onEmpty?: React.ReactNode;
    match?: any;
    onRow(item: TData): React.ReactNode[];
    onRowRedirectUrl?(item: TData): string;
    title?: string;
}
interface SimpleDataTableState {
    redirectTo?: LinkHref;
}
export default class SimpleDataTable<TData> extends BaseComponent<SimpleDataTableProps<TData>, SimpleDataTableState> {
    constructor(props: SimpleDataTableProps<TData>) {
        super(props);
        this.state = {};
    }
    render() {
        if (this.state.redirectTo) {
            return <InternalRedirect to={this.state.redirectTo} push={true}/>;
        }
        const { onToolsSection, data, headerColumns, headerColumnClassNames, rowColumnClassName, onRow, onEmpty, title } = this.props;
        if (!data) {
            return null;
        }
        return (<TransitionAnimation>
                <LegacyDataTable title={title}>
                    <LegacyDataTableHeader>
                        {onToolsSection ? (<LegacyDataTableToolsRow>
                                <LegacyDataTableHeaderColumn colSpan={headerColumns.length}>{onToolsSection()}</LegacyDataTableHeaderColumn>
                            </LegacyDataTableToolsRow>) : null}
                        {data.length > 0 ? this.buildTableHeader(headerColumns, headerColumnClassNames!) : null}
                    </LegacyDataTableHeader>
                    <LegacyDataTableBody>
                        {data.length > 0 ? (data.map((item, index) => {
                return this.buildTableRow(item, index, onRow(item), rowColumnClassName!);
            })) : (<LegacyDataTableRow displayNoBorder={true}>
                                <LegacyDataTableRowColumn>{onEmpty}</LegacyDataTableRowColumn>
                            </LegacyDataTableRow>)}
                    </LegacyDataTableBody>
                </LegacyDataTable>
            </TransitionAnimation>);
    }
    private buildTableHeader(headerColumns: any[], columnClassNames: string[]) {
        return (<LegacyDataTableRow>
                {headerColumns.map((col, index) => {
                const props: any = {};
                if (columnClassNames) {
                    const className = columnClassNames[index];
                    props["className"] = className;
                }
                return (<LegacyDataTableHeaderColumn key={index} {...props}>
                            {col}
                        </LegacyDataTableHeaderColumn>);
            })}
            </LegacyDataTableRow>);
    }
    private buildTableRow(item: TData, index: number, rowColumns: any, className: string) {
        // Only some tables include a redirect, so only show cursor if necessary.
        const redirectUrl = getNavigationUrl(this.props, item);
        const linkClassName = redirectUrl ? styles.linkableItem : null;
        return (<LegacyDataTableRow key={index} onClick={() => this.navigate(item)}>
                {rowColumns.map((col: any, idx: number) => {
                const props: any = {};
                if (className) {
                    props["className"] = cn(className, props["className"]);
                }
                if (linkClassName) {
                    props["className"] = cn(linkClassName, props["className"]);
                }
                return (<LegacyDataTableRowColumn key={idx} {...props}>
                            {col}
                        </LegacyDataTableRowColumn>);
            })}
            </LegacyDataTableRow>);
    }
    private navigate(item: TData) {
        const redirectTo = getNavigationUrl(this.props, item);
        if (!redirectTo) {
            return;
        }
        this.setState({ redirectTo });
    }
    static displayName = "SimpleDataTable";
}
